/* eslint-disable react-hooks/exhaustive-deps */
// Import necessary dependencies and components
import HelmetMetaData from "@/components/HelmetMetaData";
import SideNavbar from "@/components/dashboard/SideNavbar";
import TopNavbar from "@/components/dashboard/TopNavbar";
import { useLayoutEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { GetRequest } from "@/lib/http";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, setLoading } from "@/redux/userReducer";
import LoadingScreen from "@/components/LoadingScreen";
import UnverifiedEmailPop from "@/components/dashboard/UnverifiedEmailPop";
import { toast } from "sonner";
import PageWrapper from "@/components/PageWrapper";
import { Capacitor } from "@capacitor/core";

const Dashboard = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const { isLoggedIn, user, loading } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  async function getData(load = true) {
    const { data, err } = await GetRequest({
      url: "/api/user",
    });

    if (!err) {
      setLoggedIn(true);
      dispatch(loginUser(data));
    } else {
      if (!load) {
        toast.error("Error", {
          description:
            "Unable to fetch user data. if this issue persist try logging out and logging in again",
        });
      }
    }
    dispatch(setLoading(false));
  }

  useLayoutEffect(() => {
    getData();
  }, []);

  const path = useLocation();
  useEffect(() => {
    if (isLoggedIn) {
      getData(false);
    }
  }, [path.pathname]);

  if (loading) {
    return !user ? <LoadingScreen /> : <></>
  }

  const platform = Capacitor.getPlatform();
  if (!isLoggedIn && !loggedIn) return <Navigate to="/login" />;

  // if (user && user.meta_data?.site_available)
  //   return <Navigate to="/maintenance" />;

  if (user && user.meta_data?.site_available === false)
    return <Navigate to="/maintenance" />;


  return (user && isLoggedIn) ? (
    <>
      <HelmetMetaData title="Dashboard | Billzpay" />
      {user.email_verified ? <></> : <UnverifiedEmailPop />}

      <div className="flex h-[100dvh] flex-col">
        <TopNavbar platform={platform} />
        <div className="pt-20 md:pt-0"></div>
        <div className="flex flex-1 overflow-hidden">
          <div className="dark:border-darkBorder hidden w-[250px] border-r md:block">
            <SideNavbar />
          </div>

          <div className="no-scrollbar max-h-screen flex-1 overflow-y-auto">
            {/* {!isPWA && showPwaMessage && (
                <PwaMessage onClose={handleClosePwaMessage} />
              )} */}
            <PageWrapper>
              <Outlet />
            </PageWrapper>
          </div>
        </div>
      </div>
    </>
  ) : <></>;
};

export default Dashboard;
